module.exports = __webpack_public_path__ + "static/img/ar-simulator.306cf0f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/ar-simulator.gif
// module id = xOWH
// module chunks = 1